<template>
  <Validator label="" :v="v" input>
    <div class="custom-input">
      <div
        :class="{
          'outline-block': true,
          'outline-block--focus': inputFocus,
          'outline-border-error': v.$invalid && v.$dirty || validation,
        }">
        <textarea
          :aria-label="montarLabel()"
          ref="textarea"
          :class="{ 'outline-border-error': (v.$invalid && v.$dirty) || validation, 'outline-input outline-textarea': true }"
          :value="value"
          :rows="rows"
          :disabled="disabled"
          :readonly="readonly"
          :required="required"
          :placeholder="placeholder"
          :maxlength="maxlength()"
          :min="min"
          @input="onInput"
      @focus="onFocus"
          @blur="onBlur"
          @change="$emit('change')"
          @keyup="$emit('keyup')"></textarea>
        <div
          :class="{
            'outline-label' : true,
            'outline-label-up': value || inputFocus || placeholder,
            'outline--focus': inputFocus,
            'outline-error': v.$invalid && v.$dirty
          }">
          {{ montarLabel() }}
        </div>
        <div class="outline-disabled"></div>
        <v-icon class="outline-icon-right">{{ iconRight }}</v-icon>
      </div>
    </div>
  </Validator>
</template>

<script>
import Validator from './Valitador.vue';

export default {
  name: 'TextArea',
  components: {
    Validator,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: String,
    iconRight: String ,
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Boolean,
      default: false,
    },
    min: Number,
    rows: [String, Number],
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $params: [],
          $touch: () => {},
        };
      },
    },
  },
  data() {
    return {
      inputFocus: false,
    };
  },
  methods: {
    onInput(event) {
      if (this.maxlength()) { event.target.value = event.target.value.substring(0, this.maxlength()); }
      this.$emit('input', event.target.value);
    },
    onFocus() {
      this.inputFocus = true;
      this.$emit('focus');
    },
    onBlur() {
      this.v.$touch();
      this.inputFocus = false;

      if (this.value == '') { this.$emit('input', ''); }

      this.$emit('blur');
    },
    maxlength() {
      if (typeof this.v.$params.maxLength === 'undefined') { return; }

      return this.v.$params.maxLength.max;
    },
    montarLabel() {
      return `${this.label}${(typeof this.v.$params.required !== 'undefined' && this.v.$params.required != null) ? '*' : ''}`;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/input.scss';

.outline-textarea{
  min-height: 52px;
  padding: 15px 16px 0px 16px!important;
}
</style>
